import { message } from "antd";

message.config({ maxCount: 1, duration: 1 });
const utils = {
  showSucesso: msg => {
    return message.success(msg);
  },

  showWarning: msg => {
    return message.warning(msg);
  },

  showErro: msg => {
    return message.error(msg);
  },
};

export default utils;
